const TRACKING_ORIGINS = {
  DETAIL_TOPBAR_AD_SHARED: 'Detail Topbar Ad Shared',
  DETAIL_AD_SHARED: 'Detail Ad Shared',
  IMAGE_GALLERY_AD_SHARED: 'Image Gallery Ad Shared',
  ADS_LIST_AD_SHARED: 'List Ad Shared',
  ADS_LIST_MENU_AD_SHARED: 'List 3p Menu Ad Shared'
}

export {TRACKING_ORIGINS as trackingOrigins}
